import { render } from "./BookingFormSubmitted.vue?vue&type=template&id=28aee90b"
import script from "./BookingFormSubmitted.vue?vue&type=script&lang=js"
export * from "./BookingFormSubmitted.vue?vue&type=script&lang=js"

import "./BookingFormSubmitted.vue?vue&type=style&index=0&id=28aee90b&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__